import {z} from '@hono/zod-openapi';

import {amount} from './amount';

export const ArticleStatisticsMonthSchema = z
  .object({
    month: z.string().regex(/^\d{4}-\d{2}$/),
    issuedQuantity: amount.nullable(),
    returnedQuantity: amount.nullable(),
    netIssuedQuantity: amount.nullable(),
    endQuantity: amount.nullable(),
    endPurchaseValue: amount.nullable(),
  })
  .openapi('ArticleStatisticsMonth');
